<div *ngIf="listItem" class="file-row noselect {{listItem['itemFullData']['list_class']}}"
     [class.player-row]="true"
     [class.center75]="true"
     (click)="clickOnItem($event)">
  <div matBadge="{{listItem.itemFullData.cup_position ? listItem.itemFullData.cup_position : ''}}" matBadgeColor="accent">
    <img alt="" title="{{listItem.name}}"
         src="{{listItem.picture_ava}}" class="list-item-image"
         style="{{ listItem.itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
    />
  </div>

  <div class="file-name noselect" style="width: 80%;">
    {{listItem.name}}<br/>
    <div class="subrow subrow-trainer flex-row-center whitespace-normal subrow-min-margin">
      <mat-icon class="player-status-icon" *ngIf="!listItem.itemFullData.has_active_game">person_pin</mat-icon>
      <mat-icon class="player-status-icon" *ngIf="listItem.itemFullData.has_active_game">sports_tennis</mat-icon>
      <div *ngIf="['cup_not_started','cup_closed'].includes(listItem.itemFullData.call_game_description)">
        {{'cup_player_registered' | GetLabelPipe}}
      </div>

      <div *ngIf="['me_not_registered','me_quit','me_banned'].includes(listItem.itemFullData.call_game_description)">
        <ng-container *ngIf="listItem.itemFullData.has_active_game">
          {{'cup_player_busy' | GetLabelPipe}}
          <div class="line-breaker"></div>
          <b>{{'cup_active_game' | GetLabelPipe}}:</b> {{listItem.itemFullData.games[0]['gamePayload']['profiles'][0]['shipping_name']}} - {{listItem.itemFullData.games[0]['gamePayload']['profiles'][1]['shipping_name']}}
        </ng-container>

        <ng-container *ngIf="listItem.itemFullData.id == application.user.id && !listItem.itemFullData.has_active_game">
          {{('my_incomplete_status__'+listItem.itemFullData.call_game_description) | GetLabelPipe}}
        </ng-container>
        <ng-container *ngIf="listItem.itemFullData.id != application.user.id && !listItem.itemFullData.has_active_game">
          {{('cup_player_free_but__'+listItem.itemFullData.call_game_description) | GetLabelPipe}}
        </ng-container>
      </div>

      <!-- deprecated -->
      <div *ngIf="['self_skip'].includes(listItem.itemFullData.call_game_description)">
        <ng-container *ngIf="listItem.itemFullData.has_active_game"> <!-- deprecated ? -->
<!--          {{'cup_your_position' | GetLabelPipe}}-->
<!--          <div class="line-breaker"></div>-->
          <b>{{'cup_active_game' | GetLabelPipe}}:</b> {{listItem.itemFullData.games[0]['gamePayload']['profiles'][0]['shipping_name']}} - {{listItem.itemFullData.games[0]['gamePayload']['profiles'][1]['shipping_name']}}
        </ng-container>
        <ng-container *ngIf="!listItem.itemFullData.has_active_game">
          {{'cup_your_position' | GetLabelPipe}}
        </ng-container>
        <ng-container *ngIf="!listItem.itemFullData.has_active_game">
          {{'cup_you_are_free' | GetLabelPipe}}
        </ng-container>
      </div>

      <div *ngIf="['player_not_registered','player_banned','player_left_cup'].includes(listItem.itemFullData.call_game_description)">
        {{'cup_player_status__'+listItem.itemFullData.call_game_description | GetLabelPipe}}
      </div>

      <div *ngIf="['player_game_in_progress','me_game_in_progress','already_played','player_not_in_range'].includes(listItem.itemFullData.call_game_description)">
        <ng-container *ngIf="listItem.itemFullData.has_active_game">

          <!-- simplify status for player_game_in_progress -->
          <ng-container *ngIf="listItem.itemFullData.call_game_description != 'player_game_in_progress'">
            {{'cup_player_busy'|GetLabelPipe}}
            <div class="line-breaker"></div>
          </ng-container>

          <b>{{'cup_active_game' | GetLabelPipe}}:</b> {{listItem.itemFullData.games[0]['gamePayload']['profiles'][0]['shipping_name']}} - {{listItem.itemFullData.games[0]['gamePayload']['profiles'][1]['shipping_name']}}
        </ng-container>
        <ng-container *ngIf="!listItem.itemFullData.has_active_game">
          {{('cup_player_free_but__'+listItem.itemFullData.call_game_description) | GetLabelPipe}}
        </ng-container>
      </div>

      <div *ngIf="listItem.itemFullData['id'] == application.user.id && ['mutual_game_in_progress','mutual_game_in_confirmation_vizavi_proposal','mutual_game_in_confirmation_my_proposal'].includes(listItem.itemFullData.call_game_description)">
        {{('cup_profile_mutual_game__'+listItem.itemFullData.call_game_description) | GetLabelPipe}}
      </div>
      <div *ngIf="listItem.itemFullData['id'] != application.user.id && ['mutual_game_in_progress','mutual_game_in_confirmation_vizavi_proposal','mutual_game_in_confirmation_my_proposal'].includes(listItem.itemFullData.call_game_description)">
        {{('cup_vizavi_mutual_game__'+listItem.itemFullData.call_game_description) | GetLabelPipe}}
      </div>

      <div *ngIf="['player_available'].includes(listItem.itemFullData.call_game_description)">
        {{'cup_player_available' | GetLabelPipe}}
      </div>

    </div>
  </div>
<!--  <div class="file-menu">-->
<!--    <button mat-icon-button (click)="clickOnItemMenu($event)"-->
<!--            [matMenuTriggerFor]="trainerMenu">-->
<!--      <mat-icon>more_horiz</mat-icon>-->
<!--    </button>-->
<!--  </div>-->
</div>

<!--<mat-menu #trainerMenu="matMenu" class="file-menu">-->
<!--  <button mat-menu-item (click)="clickMenu('info')">-->
<!--    <mat-icon>info</mat-icon>{{'more'|GetLabelPipe}}-->
<!--  </button>-->
<!--</mat-menu>-->
